import { useLang } from "hooks/useLang"
import React, { useMemo, useState } from "react"

interface IProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  inputID?: string
  label?: string
  error?: string
  reqStar?: boolean
  value: string
  maxLength: number
}

const TextArea = ({
  inputID,
  label,
  error,
  reqStar = false,
  value,
  ...props
}: IProps) => {
  const [isFocused, setIsFocused] = useState(false)
  const { t } = useLang()

  const charactersLength: number = props.maxLength - value.length

  const handleFocus = () => {
    setIsFocused(true)
  }

  const handleBlur = () => {
    setIsFocused(false)
  }


  const style = useMemo(() => {
    return {
      label: `text-md transition-all md:text-base pb-1 text-gray-600 dark:text-gray-200 ${reqStar ? "after:content-['*'] after:text-red-500" : ""
        }`,
      inputContainer: `flex border rounded-md transition-all overflow-hidden inputContainer bg-white dark:bg-opacity-20 bg-opacity-40 dark:bg-primary-theme-500 ${isFocused ? "border-blue-500" : "border-gray-300"
        } ${error ? "errorStyle" : ""}`,
    }
  }, [error, isFocused])


  return (
    <div className="flex flex-col">
      <label
        className={`${style.label} text-md`}
        htmlFor={inputID}>
        {label}
      </label>
      <div className={style.inputContainer}>
        <textarea
          className="w-full resize-none border-none bg-transparent p-2 text-sm"
          onFocus={handleFocus}
          onBlur={handleBlur}
          value={value}
          {...props}
        />
      </div>
      {error ? (
        <span className="pt-1 text-xs text-red-500 dark:text-red-400">
          {t(error)}
        </span>
      ) : null}
      {charactersLength === 0 ? (
        <span className="pt-2 text-xs text-warning-theme-400 dark:text-warning-theme-400">
          {t("textarea_hitTheMax")}
        </span>
      ) : charactersLength < 11 ? (
        <span className="pt-2 text-xs text-warning-theme-400 dark:text-warning-theme-400">
          {t("charactersLength")} {charactersLength}
        </span>
      ) : null}
    </div>
  )
}

export default TextArea
